// eslint-disable-next-line no-unused-vars
import * as React from "react";
import styled from "@emotion/styled";
import { FileType } from "ui/Scripts/source/models/enums";

export const Container = styled.div`
    position: relative;
`;

const getBannerColor = (status: FileType) => {
    switch (status) {
    case FileType.Pdf:
        return "#D03E3E";
    case FileType.Image:
        return "#156DEE";
    case FileType.Html:
        return "#156DEE";
    case FileType.Excel:
        return "#0A823A";
    case FileType.Word:
        return "#185ABD";
    case FileType.PowerPoint:
        return "#C13B1A";
    case FileType.Archive:
        return "#EFCD34";
    case FileType.Document:
        return "#434549";
    default:
        return "#848688";
    }
};

export const Label = styled.div<{ fileType: FileType, size: "medium" | "large" }>`
    position: absolute;
    width: ${({ size }) => size === "medium" ? "22px" : "33px"};
    height: ${({ size }) => size === "medium" ? "10px" : "16px"};
    top: ${({ size }) => size === "medium" ? "8px" : "10px"};
    font-size: ${({ size }) => size === "medium" ? "10px" : "14px"};
    line-height: ${({ size }) => size === "medium" ? "11px" : "16px"};
    color: #fff;
    text-align: center;
    background: ${({ fileType }) => getBannerColor(fileType)}
`;